import React from 'react';

export default function DemoBanner() {
  return (
    <div style={{
      background: 'linear-gradient(90deg, #0ff4c6 0%, #0bc89e 50%, #0ff4c6 100%)',
      backgroundSize: '200% auto',
      animation: 'shimmer 3s linear infinite',
      color: '#080b14',
      textAlign: 'center',
      padding: '9px 1rem',
      fontSize: '13px',
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: '500',
      letterSpacing: '0.01em',
    }}>
      <span style={{
        display: 'inline-block',
        background: '#080b14',
        color: '#0ff4c6',
        fontSize: '10px',
        fontWeight: '700',
        padding: '2px 10px',
        borderRadius: '999px',
        marginRight: '10px',
        fontFamily: "'Syne', sans-serif",
        letterSpacing: '0.08em',
      }}>LIMITED</span>
      Take a <strong>free demo class</strong> now — unlock{' '}
      <strong style={{ color: '#080b14' }}>30% off</strong> when you enroll!
      <style>{`@keyframes shimmer { 0%{background-position:-200% center} 100%{background-position:200% center} }`}</style>
    </div>
  );
}
